import React, { useCallback, useRef, useState } from "react";
import { Button, Drawer, Tabs } from "antd";
import { arrayToObject, getLastDomByClassName } from "../../../utils";
import usePortal from "react-useportal";
import {
  TI_LIST_CLOSE_BUTTON,
  TI_MODAL_RESULT_BUTTON,
  TI_MODAL_RESULT_CLOSE_BUTTON,
  TI_SHOW_LIST_BUTTON,
} from "../../../Constants";
import { StyledButton } from "../../../styled-components/Button";
import StyledTableHeader from "../../../styled-components/StyledTableHeader";
import ExportExcelButton from "../../../utils/export";

function WidgetRisingTabsPublicStatStation({
  children,
  height,
  titleOnInit,
  elementForShowListButton,
}) {
  const [visible, setVisible] = useState(false);
  const [titleDict, setTitleDict] = useState(arrayToObject(titleOnInit));
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const setTitleWithIndex = useCallback((title, index) => {
    setTitleDict((prev) => ({
      ...prev,
      [index]: title,
    }));
  }, []);

  const tabProps = {
    activeTabIndex,
    visible,
    setTitleWithIndex,
  };

  const { Portal } = usePortal({
    bindTo:
      elementForShowListButton || getLastDomByClassName("toolbar-show-list"),
  });

  const showListButtonRef = useRef();

  return (
    <>
      <Portal>
        <StyledButton
          isActive={visible}
          onClick={() => setVisible(true)}
          tabIndex={TI_SHOW_LIST_BUTTON}
          ref={showListButtonRef}
        >
          목록 보기
        </StyledButton>
      </Portal>

      <Drawer
        placement={"bottom"}
        height={height || 620}
        closable={false}
        onClose={() => setVisible(false)}
        bodyStyle={{ padding: 12, overflowX: "scroll" }}
        visible={visible}
      >
        <>
          <StyledTableHeader>
            <span>{titleOnInit}</span>
            <StyledButton
              // tabIndex={TI_LIST_CLOSE_BUTTON}
              aria-label="닫기"
              onClick={() => {
                showListButtonRef.current.focus();
                setVisible(false);
              }}
              // tabIndex={TI_MODAL_RESULT_CLOSE_BUTTON}
            >
              닫기
            </StyledButton>
          </StyledTableHeader>
          {children && !Array.isArray(children) && (
            <div>
              {React.cloneElement(children, { tabIndex: 0, ...tabProps })}
            </div>
          )}
          {Array.isArray(children) &&
            children.map((child, tabIndex) => (
              <div>{React.cloneElement(child, { tabIndex, ...tabProps })}</div>
            ))}
        </>
      </Drawer>
    </>
  );
}

export default WidgetRisingTabsPublicStatStation;
